import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import LayersIcon from "@mui/icons-material/Layers";
import WindowOutlinedIcon from "@mui/icons-material/WindowOutlined";
import { Box, ToggleButtonGroup, ToggleButton } from "@mui/material";

import { PclDisplayType } from "../../PublicProducts.screen";
import FilterDisplayButton from "../Filter/FilterDisplayButton";

interface PclControlProps {
  showFilters: boolean;
  productsView: string;

  handleShowFilter: () => void;
  onDisplayChange: (_type: PclDisplayType) => void;
}

const PclControls = ({
  showFilters,
  handleShowFilter,
  onDisplayChange,
}: PclControlProps) => {
  return (
    <Box display="flex">
      <Box
        sx={{
          flex: "0 1 283px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FilterDisplayButton onClick={handleShowFilter} show={showFilters} />
      </Box>

      <Box flex={5} sx={{ display: "flex", marginLeft: "1em" }}>
        <ToggleButtonGroup
          exclusive
          defaultValue={1}
          sx={{
            flex: 5,
            justifyContent: "center",
          }}
        >
          <ToggleButton
            value={1}
            id="table-btn"
            onClick={() => onDisplayChange("Table")}
          >
            <FormatListBulletedIcon />
            <span className="visually-hidden">Table View</span>
          </ToggleButton>

          <ToggleButton
            value={2}
            id="list-btn"
            onClick={() => onDisplayChange("List")}
          >
            <LayersIcon />
            <span className="visually-hidden">List View</span>
          </ToggleButton>

          <ToggleButton
            value={3}
            id="grid-btn"
            onClick={() => onDisplayChange("Grid")}
          >
            <WindowOutlinedIcon />
            <span className="visually-hidden">Grid View</span>
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};
export default PclControls;
